import { render, staticRenderFns } from "./TenantsWidget.vue?vue&type=template&id=31579877&scoped=true"
import script from "./TenantsWidget.vue?vue&type=script&lang=js"
export * from "./TenantsWidget.vue?vue&type=script&lang=js"
import style0 from "./TenantsWidget.vue?vue&type=style&index=0&id=31579877&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31579877",
  null
  
)

export default component.exports